// TablePendingTransfer.js

import React from "react";
import { useTable } from "react-table";
import "../styles/table.css";

const TablePendingTransfer = ({ columns, data }) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data });

  return (
    <table id="table" {...getTableProps()} style={{ width: "100%" }}>
      <thead>
        {headerGroups.map((headerGroup, idx) => (
          <tr
            key={headerGroup.id || idx}
            {...headerGroup.getHeaderGroupProps()}
          >
            {headerGroup.headers.map((column) => (
              <th key={column.id} {...column.getHeaderProps()}>
                {column.render("Header")}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          return (
            <tr key={row.id} {...row.getRowProps()}>
              {row.cells.map((cell) => (
                <td key={cell.column.id} {...cell.getCellProps()}>
                  {cell.render("Cell")}
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default TablePendingTransfer;
